import {v4} from 'uuid'

// 该函数专门用于提供用户临时身份，【有之前的身份，就返回给使用者】，【没有之前的身份，那就生成一个新的】
export function getUserTempId(){
  // 读取localStorage中的身份
  const userTempId = localStorage.getItem('userTempId')
  // 判断是否有
  if(userTempId){
    // 若有，直接返回
    return userTempId
  }else{
    // 若没有：①生成一个新的。②存入localStorage中。③返回出去
    const newUserTempId = v4()
    // 存入localStorage中
    localStorage.setItem('userTempId',newUserTempId)
    // 返回出去
    return newUserTempId
  }
}

// 保存token
export function saveToken(token){
  localStorage.setItem('token',token)
}

// 读取token
export function readToken(){
  return localStorage.getItem('token')
}

// 删除token
export function deleteToken(){
  localStorage.removeItem('token')
}
